import React, { useContext } from 'react';
import { Auth } from 'aws-amplify';
import { AuthContext } from 'appRoot/auth/AuthContext';
import { InnerWrapper } from 'profileManagement/InnerWrapper';
import { LoadingOverlay } from '../../util-components/layout/LoadingOverlay';
import { MfaVerificationForm } from './MfaVerificationForm';

const MfaChallenge = () => {
   const { challengedUser, setAuthState } = useContext(AuthContext);
   const [error, setError] = React.useState(null);
   const [loading, setLoading] = React.useState(false);

   const handleSubmit = async ({ verificationCode }) => {
      setError(null);
      setLoading(true);
        try {
             await Auth.confirmSignIn(
                challengedUser,
                verificationCode,
                challengedUser.challengeName // SMS_MFA or SOFTWARE_TOKEN_MFA
             );

             // On success, setAuthState to loggedIn
             setAuthState('loggedIn');
          } catch (err) {
             setError(err?.message || 'Invalid verification code. Please try again.');
             setLoading(false);
          }
   };

   return (
       <div className="container">
          <InnerWrapper className="mb-5">
             {error && (
                 <div className="alert alert-danger pl-3 mt-5">
                    {error}
                 </div>
             )}

             <h1 className="mt-5">Multi-Factor Verification</h1>
             <p>
                Enter the verification code from your authenticator app to
                complete login
             </p>

             <MfaVerificationForm
                 onSubmit={handleSubmit}
                 submitButtonText="Verify"
             />
          </InnerWrapper>

          {loading && <LoadingOverlay />}
       </div>
   );
};

export { MfaChallenge };
